import { AttendanceType } from 'types';

type attendances = Array<{
  id: string;
  attendance?: boolean | null;
  source?: string | null;
  markedAt?: string | null;
  markedByName?: string | null;
  student?: {
    id?: string;
    user?: {
      firstName: string;
      lastName: string;
    } | null;
  };
} | null>;

export const transformAttendances = (attendances: attendances): AttendanceType[] =>
  attendances.reduce((attendancesArray: AttendanceType[], attendance) => {
    if (!attendance?.student?.user) {
      return attendancesArray;
    }

    return [
      ...attendancesArray,
      {
        attendanceId: attendance?.id,
        studentId: attendance?.student?.id,
        studentName: `${attendance?.student?.user?.firstName} ${attendance?.student?.user?.lastName}`,
        checked: Boolean(attendance.attendance),
        // null ≠ false: журнал, который никто не открывал, и журнал, где всем
        // проставлено «не был», выглядели одинаково.
        isUnmarked: attendance.attendance === null || attendance.attendance === undefined,
        source: attendance.source || '',
        markedAt: attendance.markedAt ?? null,
        markedByName: attendance.markedByName ?? null,
      },
    ];
  }, []);
